/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ClusterLifecycleStates } from '../../server';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const PatchClusterLifecycleState = {
  id: 'cluster-lifecycle-state.patch',
  tag: 'Cluster',
  summary: 'Update cluster lifecycle state',
  description: 'Update cluster lifecycle state within an organization project',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/lifecycle`,
  request: {
    params: Params,
    body: {
      required: true,
      content: {
        'application/json': {
          schema: z.strictObject({
            state: z.nativeEnum(ClusterLifecycleStates),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
